
class Ball {
  /**
  * @constructor
  * @param {Number} number
  */
  constructor(number) {
    this.number = number;
    this.setStatus();
  }

  /**
  * Set ball status
  * @param {Boolean} active
  */
  setStatus(active = false) {
    this.status = active;
  }
}

export default Ball;



// WEBPACK FOOTER //
// ball.js